

















































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import {
  mdiMagnify,
  mdiBellOutline,
  mdiChevronDown,
  mdiClose,
  mdiShare,
  mdiEmailOutline,
} from '@mdi/js';

import LKMenuDropDown from '@/components/elements/other/LKMenuDropDown.vue';
import NotificationDropDown from '@/components/elements/other/NotificationDropDown.vue';
import { AuthModule } from '@/store/modules/auth';
import { NotificationModule } from '@/store/modules/notifications';
import { NotificationDocModule } from '@/store/modules/notificationsDocuments';
import { NotificationType } from '@/utils/dictionaries';
import HeaderSearch from '@/components/base/HeaderSearch.vue';
import { RouteName } from '@/router';

@Component({
  components: {
    HeaderSearch,
    NotificationDropDown,
    LKMenuDropDown,
  },
  data() {
    return {
      RouteName,
      mdiMagnify,
      mdiBellOutline,
      mdiChevronDown,
      mdiClose,
      mdiShare,
      mdiEmailOutline,
      avatar: false,
      NotificationType,
    };
  },
})
export default class Header extends Vue {
  mobileMenu = false;

  @Watch('$route')
  onChangeRoute() {
    this.mobileMenu = false;
  }

  get isAuthenticated() {
    return AuthModule.isAuthenticated;
  }

  get userFullName() {
    return AuthModule.userFullName;
  }

  get newNotificationCount() {
    return NotificationModule.newCount;
  }

  get newNotificationDocCount() {
    return NotificationDocModule.newCount;
  }

  get getLetterByName() {
    return AuthModule.avatarLetter;
  }

  goToLink() {
    this.mobileMenu = false;
  }

  logout() {
    AuthModule.logout();
  }
}
